<template>
  <div :disabled="button_loading" id="page-loading">
    <!-- add/editfamzy charge form  -->
    
    <div class="vx-row mb-2">
      <div class="vx-col w-full md:w-1/3 sm:w-1/2">
        <vs-input
          class="w-full"
          label-placeholder="Terms & Conditions"
          v-model="t_a_c"
          v-validate="'required|url'"
          type="text"
          name="t_and_c"
          @keyup.enter="addUpdateCharge()"
        />
        <span class="text-danger text-sm">{{ errors.first("t_and_c") }}</span>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full md:w-1/3 sm:w-1/2">
        <vs-input
          class="w-full"
          label-placeholder="Privacy Policy"
          v-model="p_p"
          v-validate="'required|url'"
          type="text"
          name="privacy_policy"
          @keyup.enter="addUpdateCharge()"
        />
        <span class="text-danger text-sm">{{ errors.first("privacy_policy") }}</span>
      </div>
    </div>
    <!-- end add/editfamzy charge form  -->

    <div class="vx-row">
      <div class="vx-col w-full col md:w-1/3 sm:w-1/2 pt-4 text-center">
        <vs-button
          class="mr-3 mb-2 success"
          color="success"
          @click.prevent="addUpdateCharge()"
          >{{ $t("labels.Submit") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      charge: "",
      p_p:"",
      t_a_c:"",
    };
  },

  mounted() {
    this.setValidationMessage();
    this.getTermsAndConditionsDetail();
    this.getHelpAndSupportDetail();
  },

  methods: {
    loading() {
      this.loading(true, "#page-loading");
    },
    // get view Service provider charge form
    getViewDetail() {
      this.button_loader_success(true, "#page-loading");
      let input = {
        charge: this.value,
        code: "service_provider_percentage",
      };

      axios
        .get("admin/getCharge/service_provider_percentage", input)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          console.log(response);
          let data = response.data.data;
          this.charge = data[0].value;
          console.log(this.charge);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    getHelpAndSupportDetail() {
      this.button_loader_success(true, "#page-loading");
      axios
        .get("admin/getPrivacyPolicy")
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          console.log(response);
          let data = response.data.data;
          this.p_p = data[0].code;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    getTermsAndConditionsDetail() {
      this.button_loader_success(true, "#page-loading");
      axios
        .get("admin/getTermsAndConditions")
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          console.log(response);
          let data = response.data.data;
          this.t_a_c = data[0].code;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    // update form
    addUpdateCharge() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader_success(false, "#page-loading");
          this.saveCharge();
        }
      });
    },
    // save/add form
    saveCharge() {
      this.button_loader_success(true, "#page-loading");
      let input = {
        t_a_c: this.t_a_c,
        p_p:this.p_p,
      };
      axios
        .post("admin/updateTermsPrivacy", input)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          let data = response.data;
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
        })
        .catch((e) => {
          this.showError(e);
        });
    },
  },

  clearInput() {
    charge = null;
  },
};
</script>